import {decryptData} from '@/utils/encryptionUtils';
import {useRouter} from '@sttedra_ui/framework';
import {useStore} from 'vuex';
import {getValorConfiguracionByClave} from '@/api/controller/app/app-controller';
import {useMsal} from '@sttedra_ui/framework';

const router = useRouter();
const msal = useMsal();
const permisosNuevos = null;

const getCompareRoles = (_requiredRole, _userRoles) => {
  return !_requiredRole.every((_element) => {
    return !_userRoles.includes(parseInt(_element));
  });
};

const comprobarMantenimiento = async (to, from) => {
  const store = useStore();

  const account = msal.activeAccountRef.value;

  if (!account && to.redirectedFrom) {
    // Guardamos la URL exacta a la que quería entrar
    sessionStorage.setItem('postLoginRedirect', to.redirectedFrom.fullPath);
    return; // Importante: detener el flujo
  }

  // Restaurar la URL original después del login MSAL
  const saved = sessionStorage.getItem('postLoginRedirect');

  if (saved && account) {
    sessionStorage.removeItem('postLoginRedirect');
    router.push({path: saved});
    return; // Muy importante: evita que siga ejecutando el resto
  }


  if (localStorage.getItem('_config')) {
    let rolesUser = [];

    const configUser = JSON.parse(
      decryptData(localStorage.getItem('_config')),
    );
    if (configUser.roles) {
      rolesUser = configUser.roles;
    }

    const modoMantenimiento = await getValorConfiguracionByClave('ModoMantenimiento');
    const nombreRuta = to.matched[0]?.name;

    if (nombreRuta === 'ModoMantenimientoView' && modoMantenimiento === 'false') {
      router.push('/');
      return;
    }

    if (nombreRuta !== 'ModoMantenimientoView' && modoMantenimiento === 'true' &&
        !getCompareRoles([store.getters['enums/getTiposPermisoByKey']('SuperAdministrador')],
          rolesUser)) {
      router.push({name: 'ModoMantenimientoView'});
    }
  } else {
    if (to.matched[0]?.name !== 'FalloIniciarLoginView') {
      router.push({name: 'FalloIniciarLoginView'});
    }
  }
};

async function permiso(to) {
  if (to.meta.roles) {
    if (localStorage.getItem('_config')) {
      const configUser = JSON.parse(
        decryptData(localStorage.getItem('_config')),
      );

      if (permisosNuevos) {
        const store = useStore();
        store.commit('auth/setSaveDataUser', configUser);
      }

      if (configUser.roles) {
        if (!getCompareRoles(to.meta.roles, configUser.roles)) {
          router.push({path: '/permisos-insuficientes'});
        }
      } else {
        router.push({path: '/'});
      }
    } else {
      router.push({path: '/'});
    }
  }
  return true;
}

export default [permiso, comprobarMantenimiento];
